import { Amplify } from 'aws-amplify';

/**
 * AWS Amplify Configuration
 * Configures Cognito authentication
 *
 * Environment variables required:
 * - VITE_AWS_REGION
 * - VITE_COGNITO_USER_POOL_ID
 * - VITE_COGNITO_CLIENT_ID
 */

const awsConfig = {
  Auth: {
    Cognito: {
      // AWS Region — required at build time; no silent fallback (the
      // wrong-region bug is nastier than a loud build-time crash).
      region: (() => {
        const r = import.meta.env.VITE_AWS_REGION;
        if (!r) {
          throw new Error('VITE_AWS_REGION is required at build time');
        }
        return r;
      })(),

      // Cognito User Pool ID
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',

      // Cognito App Client ID (no secret)
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',

      // Only include identityPoolId when explicitly configured — passing
      // undefined causes Amplify to attempt identity pool auth and fail.
      ...(import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID && {
        identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID,
      }),

      // Sign-in options
      loginWith: {
        email: true,
        username: false,
      },
    },
  },
};

/**
 * Initialize Amplify with configuration
 * Call this once at app startup
 */
export function configureAmplify() {
  try {
    Amplify.configure(awsConfig as Parameters<typeof Amplify.configure>[0]);
    console.log('[Amplify] Configured successfully');
  } catch (error) {
    console.error('[Amplify] Configuration failed:', error);
  }
}

/**
 * Get current Amplify configuration
 * Useful for debugging
 */
export function getAmplifyConfig() {
  return awsConfig;
}
